import {config as numberPercentColumnConfig} from '../../common/NumberPercentColumn';

export const prop = 'pATOD';
export const id = 'preparerOverdueColumn';

export const config = (labels) =>
	numberPercentColumnConfig({
		fullId: id,
		label: labels.overdueLabel,
		prop,
		getPartial: (item) => item[prop],
		getTotal: (item) => item['pATot'],
		width: 'minmax(var(--px-130), 1fr)'
	});
